import { onMounted, ref } from 'vue'

import type { CountryOption } from './types'

import { getCountriesList, mapCountries } from '../api'

const cachedCountries = ref<CountryOption[] | null>(null)

export function useModel() {
    async function fetchCountries() {
        if (cachedCountries.value) return

        const response = await getCountriesList()
        if (!response || !response.country_list?.length) return

        cachedCountries.value = mapCountries(response.country_list)
    }

    onMounted(fetchCountries)

    return {
        countries: cachedCountries,
    }
}
